import { render } from "./ViewFlaggedPollsDialog.vue?vue&type=template&id=2b2be57e&scoped=true"
import script from "./ViewFlaggedPollsDialog.vue?vue&type=script&lang=js"
export * from "./ViewFlaggedPollsDialog.vue?vue&type=script&lang=js"

import "./ViewFlaggedPollsDialog.vue?vue&type=style&index=0&id=2b2be57e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2be57e"]])

export default __exports__